import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { useMutation } from "@apollo/client";
import { getDeleteMutation, getQuery } from "../Helpers/mutation";
import "./ConfimationModalStyles.css";
import { Link } from "react-router-dom";
import { ERRORS } from "../../navigation/Routes";
import styles from "../SubmitModal/submitModal.module.css";
import i18n from "i18next";

import { getDeleteVariables, getVariables } from "../Helpers/functions";
import { useParams } from "react-router-dom";

import "./ConfimationModalStyles.css";
import { setData } from "./functions";

const DEFAULT_MESSAGE =
  "Confermi la cancellazione della riga di rendicontazione?";

const getMessage = (structureName, message) => {
  if (message) return message;
  else if (structureName === "Project") return i18n.t("chooseActionMsg");
  else return DEFAULT_MESSAGE;
};

const ConfirmationModal = ({
  toggleModal,
  isModalOpen,
  label = "Canc.",
  structureName,
  values,
  setValues,
  message,
  isError,
  orgVersionId,
  isLoading = true,
  doSubmitMutation,
  setIsLoading,
  isStatusLoading,
  setAlertMessage = () => {},
  setAlertOpen = () => {},
}) => {
  const { structureId } = useParams();

  const [doDelete] = useMutation(getDeleteMutation(structureName));

  const handleToggled = (state) => {
    toggleModal(state);
    setValues(null);
  };

  const handleDelete = async () => {
    try {
      setAlertOpen(false);
      setAlertMessage("");
      await doDelete({
        variables: getDeleteVariables(values, structureName),
        update: (proxy) => {
          const data = proxy.readQuery({
            query: getQuery(structureName),
            variables: getVariables({
              structureName: structureName,
              ogrID: orgVersionId,
              structureId: structureId,
              values: values,
            }),
          });
          proxy.writeQuery({
            query: getQuery(structureName),
            variables: getVariables({
              structureName: structureName,
              ogrID: orgVersionId,
              structureId: structureId,
              values: values,
            }),
            data: setData(data, values, structureName),
          });
        },
      });
    } catch (e) {
      setAlertMessage(e.message);
      setAlertOpen(true);
    } finally {
      handleToggled(false);
    }
  };

  const handleSubmint = async (status) => {
    try {
      setIsLoading(true);
      setAlertOpen(false);
      setAlertMessage("");
      await doSubmitMutation({
        variables: {
          orgVersionId: values.orgVersionId,
          newStatus: status,
        },
      });
    } catch (e) {
      setAlertMessage(e.message);
      setAlertOpen(true);
    } finally {
      handleToggled(false);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Button
        color="danger"
        onClick={() => {
          handleToggled(false);
        }}
      >
        {label}
      </Button>
      <Modal
        isOpen={isModalOpen}
        toggle={() => {
          handleToggled(false);
        }}
        className="text"
      >
        {
          <Spinner
            className={styles.spinner}
            animation="border"
            hidden={isLoading}
          />
        }
        {isLoading && (
          <ModalHeader toggle={() => handleToggled(false)}>
            {getMessage(structureName, message)}
          </ModalHeader>
        )}
        {isError && (
          <Link
            to={`${ERRORS}/${orgVersionId}`}
            onClick={() => handleToggled(false)}
          >
            Errori e Avvisi
          </Link>
        )}

        {!message && isLoading === undefined && (
          <ModalBody>
            <h4>{DEFAULT_MESSAGE}</h4>
          </ModalBody>
        )}
        <ModalFooter>
          {label === "Canc." && structureName !== "Project" && (
            <Button color="danger" onClick={handleDelete}>
              OK
            </Button>
          )}
          <Button
            hidden={true}
            variant="secondary"
            onClick={() => {
              handleToggled(false);
            }}
          >
            {label !== "Canc." ? "OK" : "Annulla"}
          </Button>
          {structureName === "Project" && (
            <Row>
              <Col>
                <Button
                  color="danger"
                  disabled={isStatusLoading}
                  onClick={async () => handleSubmint("VERIFIED")}
                >
                  {i18n.t("verifyStatusBtn")}
                </Button>
              </Col>
              <Col>
                <Button
                  color="success"
                  disabled={isStatusLoading}
                  onClick={async () => handleSubmint("APPROVED")}
                >
                  {i18n.t("approveStatus")}
                </Button>
              </Col>
            </Row>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
